<template>
  <div class="Main">
    <Header @filterTree="filterTree"></Header>
    <router-view :TreeIndex='TreeIndex' ref="rout"></router-view>
  </div>
</template>
<script>
import { defineComponent,ref,getCurrentInstance} from 'vue'
import Header from '@/components/header/Header' 
// import Aside from '@/components/aside/Aside'

export default defineComponent({
  name: 'Layout',
  components: {
    Header,
    // Aside,
  },
  setup(props, ctx) {
    // const currentInstance = getCurrentInstance();
    let TreeIndex=ref("")
    let filterTree = (param) => {
      TreeIndex.value=param;
      // console.log('TreeIndex',TreeIndex);
    }
    return {
      filterTree,
      TreeIndex
    }
  },
  
})
</script>

<style lang="scss">
  .Main{
    background-color: #2c3242;
    // .content{
    //   display: flex;
    //   width: 100%;
    //   margin-top: 10px;
    // }
    // .Mbutton{
    //   width: 20px;
    //   margin-right: 10px;
    //   margin-bottom: 10px;
    //   background-color: #2c3242;
    //   display: flex;
    //   .op-button{
    //     display: flex;
    //     color: #359186;
    //     width: 20px;
    //     height: 40px;
    //     margin: auto;
    //     align-items: center;
    //     justify-content: center;
    //     // text-align: center;
    //     background-color: #303749;
    //   }
    // }
    ::-webkit-scrollbar{
      width:5px;
      height: 5px;
      margin-left: 50%;
      background-color: #061d74;
    }
    ::-webkit-scrollbar-thumb{
      margin-left: 50%;
      background-color: #646563;
    }
  }

</style>
